import React, { useRef } from 'react';
import './TimeMap.scss';
import ChartMap from './ChartMap';
import { generateColorConfig } from './MapUtlitiy';
import {getDateString} from "../../../../../../tokens/js/utils/functions";

const timeLabels = {
  months: [
    'Januar',
    'Februar',
    'März',
    'April',
    'Mai',
    'Juni',
    'Juli',
    'August',
    'September',
    'Oktober',
    'November',
    'Dezember',
  ],
  quarter: ['Frühjahr', 'Sommer', 'Herbst', 'Winter'],
  halfyear: ['Sommerhalbjahr', 'Winterhalbjahr'],
};

const characteristicsLabels = {
  'tas-TM': {
    months: [
      'tas-TM-JAN',
      'tas-TM-FEB',
      'tas-TM-MAR',
      'tas-TM-APR',
      'tas-TM-MAI',
      'tas-TM-JUN',
      'tas-TM-JUL',
      'tas-TM-AUG',
      'tas-TM-SEP',
      'tas-TM-OKT',
      'tas-TM-NOV',
      'tas-TM-DEZ',
    ],
    quarter: ['tas-TM-MAM', 'tas-TM-JJA', 'tas-TM-SON', 'tas-TM-DJF'],
    halfyear: ['tas-TM-SO', 'tas-TM-WI'],
  },
  pr: {
    months: [
      'pr-JAN',
      'pr-FEB',
      'pr-MAR',
      'pr-APR',
      'pr-MAI',
      'pr-JUN',
      'pr-JUL',
      'pr-AUG',
      'pr-SEP',
      'pr-OKT',
      'pr-NOV',
      'pr-DEZ',
    ],
    quarter: ['pr-MAM', 'pr-JJA', 'pr-SON', 'pr-DJF'],
    halfyear: ['pr-SO', 'pr-WI'],
  },
};

const getColorConfigByCharacteristic = (characteristicLabel, colorsets) => {
  const colorset = colorsets.filter((obj) => obj.var === characteristicLabel);
  const colorConfig = generateColorConfig('change', colorset);
  return colorConfig;
};

const TimeMap = ({
  size,
  shapePath,
  shape,
  data,
  latLonData,
  colorsets,
  timeWindow,
  apiParameter,
  timeCharacteristic,
  freshData,
  usp,
}) => {
  // const characteristic = apiParameter[0];
  const characteristic = timeCharacteristic.split('_')[0];
  const characteristicLabelSet =
    characteristicsLabels[characteristic][timeWindow];
  if (colorsets.length < 2) {
    return <></>;
  }

  const dateString = getDateString();
  const secondaryPdfFooter =
    data.length >= 5 && usp === 'pdf' ? (
      <div className="pdf-date_secondary">
        <p>Erstellt am: {dateString}</p>
      </div>
    ) : null;

  return (
    <>
      <div
        className={
          timeWindow !== 'months'
            ? 'vis-wrapper time-map-wrapper bigmap'
            : 'vis-wrapper time-map-wrapper smallmap'
        }
        id="vis-wrapper"
      >
        {data.map((mapData, index) => {
          const pageBreakElement =
            index === 8 && usp === 'pdf' ? (
              <div className="pagebreakElement" />
            ) : null;

          return (
            <div className={timeWindow !== 'months' ? 'bigmap' : 'smallmap'}>
              <ChartMap
                size={size}
                colorConfig={getColorConfigByCharacteristic(
                  characteristicLabelSet[index],
                  colorsets
                )}
                data={mapData}
                shape={shape}
                shapePath={shapePath}
                latLonData={latLonData}
                caption={{
                  firstLine: timeLabels[timeWindow][index],
                  secondLine: '',
                }}
                key={timeLabels[timeWindow][index]}
                showCopyright={index === 0}
                showLegend
                backdrop
              />
              {pageBreakElement}
            </div>
          );
        })}
      </div>
      {secondaryPdfFooter}
    </>
  );
};

function areEqual(prevProps, nextProps) {
  if (!nextProps.freshData) {
    return true;
  }
  return false;
  /*
  return true if passing nextProps to render would return
  the same result as passing prevProps to render,
  otherwise return false
  */
}
export default React.memo(TimeMap, areEqual);
